import { Component, Input, TemplateRef, booleanAttribute } from '@angular/core';
import { IconName } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sigecom-menu-bar',
  template: `
    <div
      class="{{ contentClass || 'flex items-center gap-4 pr-3' }}"
      [ngClass]="{ relative: enableModal }"
    >
      <ng-container *ngIf="enableModal; else notEnableModal">
        <sigecom-button
          type="default"
          outlined
          [class]="triggerClass"
          [attr.title]="triggerTitle"
          [icon]="triggerIcon"
          [title]="triggerLabel"
          (buttonClicked)="toggleModalActions()"
        />
      </ng-container>

      <ng-template #notEnableModal>
        <ng-content></ng-content>
      </ng-template>
    </div>

    <sigecom-modal
      clickOutside
      [open]="showModal"
      [showCloseButton]="true"
      [metadata]="modalMetadata"
      (modalStateChange)="changeModalState($event)"
    >
      <ng-container *ngTemplateOutlet="modalTemplate"></ng-container>
    </sigecom-modal>
  `,
})
export class MenuBarComponent {
  @Input({ transform: booleanAttribute }) enableModal: boolean = false;
  @Input() modalTemplate: TemplateRef<any> | null = null;
  @Input() contentClass: string = '';
  @Input() modalMetadata?: string;

  @Input() triggerLabel = 'Ações';
  @Input() triggerTitle = 'Ações';
  @Input() triggerIcon: IconName = 'ellipsis-vertical';
  @Input() triggerClass = '';

  showModal: boolean = false;

  toggleModalActions() {
    this.showModal = !this.showModal;
  }

  changeModalState(state: boolean) {
    this.showModal = state;
  }
}
